import { gql } from "@apollo/client";

export const RESET_PWD = gql`
  mutation resetPWD($email: String!, $randomCode: String!, $password: String!) {
      resetPWD(input: { email: $email, randomCode: $randomCode, password: $password })
  }
`;
